// extracted by mini-css-extract-plugin
export var boxItems = "_bn-1";
export var boxItemsLg = "_bn-2";
export var button = "_bn-7";
export var buttonLg = "_bn-8";
export var filterGroupBox = "_bn-0";
export var icon = "_bn-3";
export var iconSecondary = "_bn-6";
export var iconWrapper = "_bn-4";
export var iconWrapperLg = "_bn-5";